// extracted by mini-css-extract-plugin
export default {"point":"Sensor_point__XHVGp","sensor_container":"Sensor_sensor_container__h4okU","sensor":"Sensor_sensor__CJK2T"};